import { Document } from "@react-pdf/renderer";
import assetsConfig from "../../../../assetsConfig";
import {
	buildCompanyDetails,
	buildOrderSummary,
	buildPhysicalEntries,
} from "./physicalComponentPdfUtils";
import EntryManifestPage from "./EntryManifestPage";
import OrderSummaryPage from "./OrderSummaryPage";
import { registerPhysicalPdfFonts } from "./registerFonts";
import ShippingLabelPage from "./ShippingLabelPage";
import { PhysicalEntryPDFProps } from "./types";

registerPhysicalPdfFonts();

const PhysicalEntryPDF = (props: PhysicalEntryPDFProps) => {
	if (!props.company) {
		return null;
	}

	const entries = buildPhysicalEntries(props.order.lineItems);
	const summary = buildOrderSummary(props.order.id ?? 0, entries);
	const company = buildCompanyDetails(props.company);

	return (
		<Document
			title={`Physical Entry Order ${String(props.order.id)}`}
			author={assetsConfig.companyNameShort}
			keywords={assetsConfig.companyNameShort + ", Physical Entry PDF"}
		>
			<OrderSummaryPage summary={summary} labels={props.labels} />
			<ShippingLabelPage
				orderId={props.order.id ?? 0}
				entries={entries}
				verticals={summary.verticals}
				company={company}
				labels={props.labels}
			/>
			{entries.map((entry) => (
				<EntryManifestPage
					key={entry.id}
					entry={entry}
					company={company}
					labels={props.labels}
				/>
			))}
		</Document>
	);
};

export default PhysicalEntryPDF;
export type {
	PhysicalEntryPDFProps,
	DownloadPhysicalEntryPDFProps,
} from "./types";
